import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import extractDialogProps from 'components/extractDialogProps';

import useClient from 'components/Auth/useClient';

export function denyAsync(client, id, contentId) {
    const message = {
      contentId : contentId,
    }
    return client.post(`api/document/${id}/deny`, message);
  }

export default function DenyDialog(props) {
  const [dialogProps] = extractDialogProps(props);
  const {
    id,
    contentId,
    name,
    handleClose,
    handleReload,
  } = props;

  const client = useClient();
  const handleDeny = React.useCallback(() => {
    denyAsync(client, id, contentId)
      .then(() => {
        handleClose();
        handleReload();
      })
      .catch(() => {
      });
  }, [client, id, contentId, handleClose]);

  return (
    <div>
      <Dialog
        {...dialogProps}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">{name + "状態を解除しますか？"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            キャンセル
          </Button>
          <Button onClick={handleDeny} color="primary" autoFocus>
            {name}解除
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}